import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {connectApi} from "./connect-api";
import {map} from "rxjs/operators";
import {SharedDocumentsPackage} from "./shared-documents-package";
import {Observable} from "rxjs/index";
import {DocSharingMessage} from "../shared/doc-sharing-message";
import {CustomHttpParams} from "./connect-http-interceptor";
import {MatterDocument} from "../shared/matter-document";

@Injectable({
    providedIn: 'root'
})
export class DocSharingMessageService {

    constructor(private httpClient: HttpClient) {
    }

    sendMessageFromUnityConnect(matterId: number, matterDocs: MatterDocument[], message: string): Observable<DocSharingMessage> {
        const docSharingMessage: DocSharingMessage = new DocSharingMessage();
        docSharingMessage.documentIdsIncludedInMessage = matterDocs.map(matDoc => matDoc.id);
        docSharingMessage.message = message;

        const url: string = connectApi.sendMessageFromUnityConnect.replace('{matterId}', matterId.toString());

        return this.httpClient.post<DocSharingMessage>(url, docSharingMessage, {
            params: new CustomHttpParams(true)
        }).pipe(map(result => new DocSharingMessage(result['DocSharingMessage'])));
    }

    getDocSharingMessages(matterId: number): Observable<DocSharingMessage[]> {
        let url: string = connectApi.getdocSharingMessages.replace('{matterId}', matterId.toString());
        return this.httpClient.get(url, undefined)
            .pipe(map((res) => {
                return res['DocSharingMessages'].map(msg => {
                    return new DocSharingMessage(msg)
                });
            }));
    }


}
